<template>
    <div class="helper-page">
        <template v-for="item in stepOptions">
            <step-component
                :key="'STEP_OPTION_ITEM_KEY_'+item.title"
                :title="item.title"
                :sub-title="item.subTitle"
                :img="item.img"/>
        </template>
    </div>
</template>

<script>
import StepComponent from '@/views/helper/StepComponent'
export default {
    name: 'ks',
    components: { StepComponent },
    data () {
        return {
            stepOptions: [
                {
                    title: '第一步',
                    subTitle: '点击新浪微博，进入个人资料页点击微博头像，进入个人主页',
                    img: require('@/assets/sina/sina01.png')
                },
                {
                    title: '第二步',
                    subTitle: '点击个人主页右上角的“…”',
                    img: require('@/assets/sina/sina02.png')
                },
                {
                    title: '第三步',
                    subTitle: '点击“复制链接”即可获得链接',
                    img: require('@/assets/sina/sina03.png')
                }
            ]
        }
    }
}
</script>

<style scoped>

</style>
